import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`When choosing a name for your package, choose a name that`}</p>
    <ul>
      <li parentName="ul">{`is unique`}</li>
      <li parentName="ul">{`is descriptive`}</li>
      <li parentName="ul">{`meets `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/policies"
        }}>{`npm policy guidelines`}</a>{`. For example, do not give your package an offensive name, and do not use someone else's trademarked name or violate the `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/policies/trademark#the-npm-trademark-policy"
        }}>{`npm trademark policy`}</a>{`.`}</li>
    </ul>
    <p>{`Additionally, when choosing a name for an `}<a parentName="p" {...{
        "href": "creating-and-publishing-unscoped-public-packages"
      }}><strong parentName="a">{`unscoped`}</strong>{` package`}</a>{`, also choose a name that`}</p>
    <ul>
      <li parentName="ul">{`is not already owned by someone else`}</li>
      <li parentName="ul">{`is not spelled in a similar way to another package name`}</li>
      <li parentName="ul">{`will not confuse others about authorship`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      